import type { SVGProps } from "react";

function LexiconLogoClosedBook(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg1"
      width="273.227"
      height="340.427"
      version="1.1"
      viewBox="0 0 72.291 90.071"
      {...props}
    >
      <g id="layer1" fillRule="evenodd" transform="translate(-63.36 -101.365)">
        <path
          id="rect1"
          fill="#ff862f"
          fillOpacity="1"
          strokeWidth="0.261"
          d="M64.786 101.368h71.82v89.779h-71.82z"
          transform="skewX(-.374)scale(1 .99998)"
        ></path>
        <path
          id="rect2"
          fill="#f60"
          fillOpacity="1"
          strokeWidth="0.265"
          d="M70.304 114.023h60.342v20.016H70.304z"
        ></path>
        <path
          id="text1"
          fill="#fff"
          strokeWidth="0.265"
          d="M76.383 119.946v7.793h3.41v-3.218h1.29v4.513h-7.608v-1.295h1.337v-7.793h-1.337v-1.295h4.245v1.295zm13.346 5.83h-6.07q.13 1.04.806 1.646.675.6 1.654.6.716 0 1.33-.297.613-.296 1.026-.91l1.254.566q-.592.923-1.557 1.399-.958.468-2.088.468-1.171 0-2.08-.49-.91-.488-1.42-1.363-.503-.875-.503-1.971 0-1.089.496-1.964.503-.875 1.371-1.364.869-.496 1.916-.496 1.144 0 1.991.51.855.503 1.344 1.447.489.937.53 2.218m-3.838-2.991q-.806 0-1.412.544-.606.538-.779 1.427h4.534q-.2-.89-.847-1.427-.648-.544-1.496-.544m7.31.283 1.31 1.426 1.22-1.426h-.738v-1.275h3.418v1.275h-1.199l-1.909 2.17 2.302 2.529h.806v1.267h-3.418v-1.267h.93l-1.44-1.64-1.419 1.64h.93v1.267h-3.5v-1.267h1.054l2.178-2.446-2.06-2.253h-.993v-1.275h3.404v1.275zm8.42-3.714q0 .351-.254.606-.255.255-.607.255-.35 0-.599-.255-.248-.255-.248-.606 0-.352.248-.607t.6-.255q.365 0 .613.248.248.249.248.614m1.02 8.413v1.267h-3.658v-1.267h1.13v-4.7h-1.13v-1.274h2.556v5.974zm6.436-5.45v-.524h1.268v2.742h-1.268q-.083-.792-.634-1.206-.551-.42-1.275-.42-.62 0-1.116.33-.49.332-.758.897-.269.565-.269 1.233 0 1.137.607 1.86.606.717 1.598.717 1.537 0 2.17-1.426l1.186.565q-1 2.163-3.418 2.163-1.081 0-1.922-.51-.84-.51-1.302-1.399-.455-.888-.455-1.97 0-1.061.462-1.93.468-.868 1.281-1.35.813-.49 1.812-.49 1.185 0 2.033.718m9.99 3.107q0 1.054-.502 1.93-.503.874-1.371 1.384-.869.51-1.923.51-1.088 0-1.964-.51t-1.364-1.385q-.482-.875-.482-1.929 0-1.102.482-1.97.49-.869 1.358-1.358.868-.496 1.97-.496 1.068 0 1.936.524.868.516 1.365 1.391.496.875.496 1.909m-3.796 2.44q.634 0 1.165-.332.53-.33.826-.888.297-.559.297-1.22 0-.648-.297-1.206-.296-.558-.826-.896-.53-.344-1.179-.344-.633 0-1.164.338-.53.33-.834.895t-.303 1.213q0 .648.303 1.213t.84.895 1.172.331m11.769-3.7v3.603h1.212v1.267h-2.639v-4.781q0-.682-.2-.979-.192-.296-.64-.296-.951 0-2.136.937v3.852h1.247v1.267h-3.927v-1.267h1.274v-4.7h-1.274v-1.274h2.68v.875q1.33-.972 2.5-.972.972 0 1.434.6.469.6.469 1.867"
          aria-label="Lexicon"
          fontFamily="Rockwell"
          fontSize="14.111"
        ></path>
        <path
          id="rect3"
          fill="#f60"
          fillOpacity="1"
          strokeWidth="0.265"
          d="M63.359 101.365h2.944v90.071h-2.944z"
        ></path>
      </g>
    </svg>
  );
}

export default LexiconLogoClosedBook;
